<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <v-row>
        <!-- <v-col cols="4">
          <v-select
            v-model="selectedComplexId"
            :items="complexes"
            item-value="id"
            item-text="text"
            label="مجموعه"
            @change="getSubComplexes"
            solo
          ></v-select>
        </v-col>

        <v-col cols="4">
          <v-select
            v-model="selectedSubComplexId"
            :items="subComplexes"
            item-value="id"
            item-text="text"
            label="زیر مجموعه"
            @change="getDevices(selectedSubComplexId)"
            solo
          ></v-select>
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="support.deviceId"
            :items="users"
            item-value="id"
            item-text="text"
            label="دستگاه"
            solo
          ></v-select>
        </v-col> -->
      </v-row>
      <v-row>
        <calenderSelect ref="dateRef" />
      </v-row>

      <v-spacer></v-spacer>
      <br />
      <v-btn :loading="loading" color="blue darken-1" @click="submit()"
        >حذف</v-btn
      >
    </v-container>
  </v-form>
</template>

<script>
import Vue from "vue";
import request from "@/utils/request";
import calenderSelect from "@/components/common/CalenderSelect.vue";

export default Vue.extend({
  name: "FileManagment",
  components: { calenderSelect },
  data: () => ({
    startDate: false,
    endDate: false,
    dialog: false,
    valid: true,
    loading: false,
  }),

  created() {
    this.getComplexes();
  },

  methods: {
    clearFrom() {
      this.support.from = null;
    },
    clearTo() {
      this.support.to = null;
    },

    userFilter(item, queryText, itemText) {
      const searchText = queryText.toLowerCase();
    },

    submit() {
      Vue.swal({
        title: "ایا برای حذف این فولدرها مطمئن هستید",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بله ,حذف شود",
        cancelButtonText: "انصراف",
      }).then((result) => {
        if (!this.$refs.form.validate()) {
          return;
        }

        if (!this.$refs.dateRef.from) {
          alert("لطفا تاریخ شروع را وارد نمایید");
          return;
        }
        if (!this.$refs.dateRef.to) {
          alert("لطفا تاریخ پایان را وارد نمایید");
          return;
        }
        this.startDate = this.$refs.dateRef.from;
        this.endDate = this.$refs.dateRef.to;

        this.loading = true;
        request
          .get(
            `/deviceManagement/deleteFoldersByDateRange?startDate=${this.startDate}&endDate=${this.endDate}`
          )
          .then(() => {
            Vue.swal("", "فولدرها با موفقیت حذف شدند", "success");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
});
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}

.card-form-img {
  padding: 0px !important;
}

.icon-btn-modal {
  position: absolute;
  font-size: 18px !important;
  color: #fff !important;
  padding: 8px;
  border-radius: 50%;
}

.icon-btn-modal:hover {
  cursor: pointer;
}

.icon-btn-upload {
  position: absolute;
  left: 60%;
  bottom: 33%;
  color: #fff !important;
  /*padding: 8px;*/
  border-radius: 50%;
  /*background: #35495E !important;*/
  text-align: center;
  display: flex;
  margin: auto;
  justify-content: center;
  align-items: center;
  /*height: 20px !important;*/
  /*width: 20px !important;*/
}

.v-icon {
  color: #fff !important;
  font-size: 18px !important;
  text-align: center;
  background: #35495e !important;
}

.logo-title {
  text-align: center;
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
</style>
